<template>
<div class='client'>
	<span class="client-name text-strong text-indent-inline">{{ client.client_name }}</span>
	<span class="client-position">{{ client.position }}</span>
	<span class="client-start text-strong">{{ client.start }}</span>
	<span class="client-end">{{ client.end }}</span>
	<span class="client-location text-strong">{{ client.location }}</span>

	<div class="text-right">
		<prismic-link :field="client.link" class="btn">Visit Website</prismic-link>
	</div>
</div>
</template>

<script>

export default {
  name: 'Client',
  props: ['client'],
  data () {
    return {
    }
  },
	created () {
  }
}
</script>